module.exports = __webpack_public_path__ + "assets/75aa3b82d1e2e979aa884bf78b68474f.png";